module.exports = __webpack_public_path__ + "static/media/gb.fd72d9b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/navigation/languageswitch/gb.svg
// module id = 1139
// module chunks = 0